import { render, staticRenderFns } from "./acceptanceDetail.vue?vue&type=template&id=280a48b0&scoped=true&"
import script from "./acceptanceDetail.vue?vue&type=script&lang=js&"
export * from "./acceptanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./acceptanceDetail.vue?vue&type=style&index=0&id=280a48b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a48b0",
  null
  
)

export default component.exports